(function(){
  'use strict';

  if(window.ChinaTourlyEvents && window.ChinaTourlyEvents.version) return;

  var queue = window.ctEventQueue = window.ctEventQueue || [];
  var recent = Object.create(null);
  var ga4MeasurementId = 'G-SJ7XQSX2ZJ';

  function cookie(name){
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function sendGaBeacon(name, detail){
    if(!navigator.sendBeacon || typeof window.gtag !== 'function') return false;
    var clientMatch = cookie('_ga').match(/^GA\d+\.\d+\.(\d+\.\d+)$/);
    if(!clientMatch) return false;
    var params = new URLSearchParams({
      v: '2',
      tid: ga4MeasurementId,
      cid: clientMatch[1],
      en: name,
      dl: window.location.href,
      dt: document.title
    });
    var sessionMatch = cookie('_ga_' + ga4MeasurementId.slice(2)).match(/^GS\d+\.\d+\.s(\d+)\$o(\d+)/);
    if(sessionMatch){
      params.set('sid', sessionMatch[1]);
      params.set('sct', sessionMatch[2]);
    }
    Object.keys(detail || {}).slice(0, 20).forEach(function(key){
      var value = detail[key];
      if(value == null || typeof value === 'object') return;
      params.set('ep.' + key, String(value).slice(0, 300));
    });
    return navigator.sendBeacon('https://www.google-analytics.com/g/collect?' + params.toString());
  }

  function deliverLeadSignal(name, detail, done){
    var gaNames = {
      lead_intent: 'lead_intent',
      contact_whatsapp: 'contact_whatsapp',
      generate_lead: 'generate_lead',
      choose_payment_plan: 'choose_payment_plan'
    };
    if(name === 'choose_payment_plan' && sendGaBeacon(name, clean(detail || {}))){
      if(typeof done === 'function') window.setTimeout(done, 60);
    } else if(gaNames[name] && typeof window.gtag === 'function'){
      var gaPayload = clean(detail || {});
      gaPayload.transport_type = 'beacon';
      if(typeof done === 'function'){
        gaPayload.event_callback = done;
        gaPayload.event_timeout = 400;
      }
      window.gtag('event', gaNames[name], gaPayload);
    } else if(typeof done === 'function'){
      window.setTimeout(done, 0);
    }
    if(typeof window.fbq === 'function'){
      if(name === 'generate_lead') window.fbq('track', 'Lead', clean(detail || {}));
      else if(name === 'contact_whatsapp') window.fbq('track', 'Contact', clean(detail || {}));
      else if(name === 'lead_intent') window.fbq('trackCustom', 'LeadIntent', clean(detail || {}));
    }
  }

  function clean(value){
    if(value == null) return value;
    if(typeof value === 'string') return value.trim().slice(0, 500);
    if(Array.isArray(value)) return value.slice(0, 30).map(clean);
    if(typeof value === 'object'){
      var out = {};
      Object.keys(value).slice(0, 40).forEach(function(key){ out[key] = clean(value[key]); });
      return out;
    }
    return value;
  }

  function emit(name, detail, options){
    if(!name) return null;
    var payload = {
      event: String(name),
      detail: clean(detail || {}),
      page_path: window.location.pathname,
      page_type: document.body && document.body.getAttribute('data-template') || '',
      timestamp: new Date().toISOString()
    };
    var key = payload.event + '|' + JSON.stringify(payload.detail);
    var now = Date.now();
    var ttl = options && Number(options.dedupeMs) || 500;
    if(recent[key] && now - recent[key] < ttl) return null;
    recent[key] = now;
    queue.push(payload);
    deliverLeadSignal(payload.event, payload.detail, options && options.deliveryCallback);
    window.dispatchEvent(new CustomEvent('chinatourly:event', { detail: payload }));
    window.dispatchEvent(new CustomEvent('chinatourly:' + payload.event, { detail: payload }));
    return payload;
  }

  function text(root, selector){
    var el = root && root.querySelector(selector);
    return el ? el.textContent.trim() : '';
  }

  function selectedDate(root){
    var month = root.querySelector('[data-ctc-month]');
    var day = root.querySelector('[data-ctc-day]');
    var year = root.querySelector('[data-ctc-year]');
    if(!month || !day || !year || !month.value || !day.value || !year.value) return '';
    return [year.value, String(month.value).padStart(2, '0'), String(day.value).padStart(2, '0')].join('-');
  }

  function productContext(root){
    return {
      product_id: root.getAttribute('data-product-id') || '',
      product_handle: root.getAttribute('data-product-handle') || window.location.pathname.split('/').pop(),
      product_title: text(document, 'h1'),
      travellers: Number((root.querySelector('[data-ctc-qty]') || {}).value || 1),
      travel_date: selectedDate(root),
      season_window: text(root, '[data-ctc-window]')
    };
  }

  function trackProductView(){
    var root = document.querySelector('[data-ctc-booking]');
    if(!root) return;
    emit('view_item', productContext(root), { dedupeMs: 60000 });
  }

  function onChange(event){
    var target = event.target;
    if(!target || !target.closest) return;
    var root = target.closest('[data-ctc-booking]');
    if(!root) return;
    if(target.matches('[data-ctc-month], [data-ctc-day], [data-ctc-year]')){
      var date = selectedDate(root);
      if(date) emit('select_date', productContext(root), { dedupeMs: 800 });
    }
    if(target.matches('[data-ctc-qty]')){
      emit('select_travellers', productContext(root), { dedupeMs: 800 });
    }
  }

  function onClick(event){
    var target = event.target && event.target.closest ? event.target.closest('a,button') : null;
    if(!target) return;

    var root = target.closest('[data-ctc-booking]');
    if(root && target.matches('[data-ctc-pay-full], [data-ctc-pay-deposit]')){
      var plan = target.matches('[data-ctc-pay-full]') ? 'pay_in_full' : 'deposit';
      var ctx = productContext(root);
      ctx.payment_plan = plan;
      ctx.due_today = plan === 'pay_in_full' ? text(root, '[data-ctc-full-due]') : text(root, '[data-ctc-deposit]');
      var href = target.getAttribute('href') || '';
      var shouldDelayNavigation = target.tagName === 'A' && href && !event.defaultPrevented &&
        !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
        (typeof event.button !== 'number' || event.button === 0);
      var navigated = false;
      var continueToCheckout = function(){
        if(navigated || !shouldDelayNavigation) return;
        navigated = true;
        window.location.assign(href);
      };
      if(shouldDelayNavigation){
        event.preventDefault();
        window.setTimeout(continueToCheckout, 450);
      }
      emit('choose_payment_plan', ctx, { dedupeMs: 1200, deliveryCallback: continueToCheckout });
      emit('begin_checkout', ctx, { dedupeMs: 1200 });
      return;
    }

    if(root && target.matches('[data-ctc-inc], [data-ctc-dec]')){
      window.setTimeout(function(){ emit('select_travellers', productContext(root), { dedupeMs: 800 }); }, 0);
    }

    var href = target.getAttribute('href') || '';
    if(/^https:\/\/wa\.me\//i.test(href) || /whatsapp/i.test(target.textContent || '')){
      emit('contact_whatsapp', { href: href, label: target.textContent || '' }, { dedupeMs: 1200 });
    } else if(href.indexOf('/pages/start-planning') !== -1 || href.indexOf('/pages/contact') !== -1){
      emit('lead_intent', { href: href, label: target.textContent || '' }, { dedupeMs: 1200 });
    }
  }

  function trackLeadSuccess(){
    if(document.querySelector('.ct-contact-v3__success')){
      emit('generate_lead', { form: 'start_planning' }, { dedupeMs: 60000 });
    }
  }

  function boot(){
    trackProductView();
    trackLeadSuccess();
  }

  window.ChinaTourlyEvents = { version: '1.1.0', deliveryVersion: '1.1.0', emit: emit, queue: queue };
  document.addEventListener('change', onChange, true);
  document.addEventListener('click', onClick, true);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
